module.exports = __webpack_public_path__ + "static/media/card2.bb0b9b4e.svg";